import { Pagination, Navigation } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react'
import ItemCard from '../ItemCard'
import {
  CarouselWrapper,
  ImageWrapper,
  CategoryWrapper
} from './Carousel.styles'
import { CarouselProps } from './Carousel.types'
import { mergeCarouselProps } from './Carousel.utils'
import Image from '../Image'
import useId from '../../hooks/useId'

const Carousel = (props: CarouselProps) => {
  const carouselProps = mergeCarouselProps(props)
  const {
    items,
    itemCard,
    usePagination,
    isPaginationClickable,
    useNavigation,
    slidesPerView,
    onSlideChange,
    spaceBetweenSlides,
    styles,
    images,
    categoriesList,
    image,
    imageActions,
    categoryActions,
    'data-testid': testid = 'carousel',
    itemCardOrientation = 'horizontal'
  } = carouselProps
  let slidesPerViewDefault = slidesPerView

  const { getTestId } = useId(testid)
  const swiperModules = []
  let itemCardProps = { ...itemCard }
  if (usePagination) {
    swiperModules.push(Pagination)
  }
  if (useNavigation) {
    swiperModules.push(Navigation)
  }
  if (itemCardOrientation === 'vertical') {
    slidesPerViewDefault = 2.5
    itemCardProps = {
      ...itemCardProps,
      horizontal: false,
      layout: 'default',
      footer: {
        ...itemCardProps?.footer,
        columns: 1
      }
    }
  }

  const clickablePagination = usePagination ? isPaginationClickable : false
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClick = (event: any, data: any) => {
    event.preventDefault()
    event.stopPropagation()
    if (imageActions) {
      imageActions({
        data
      })
    }
  }
  if (items?.length || images?.length || categoriesList?.length) {
    return (
      <CarouselWrapper
        modules={swiperModules}
        spaceBetween={spaceBetweenSlides}
        navigation={useNavigation}
        slidesPerView={slidesPerViewDefault}
        data-testid={getTestId()}
        pagination={{ clickable: clickablePagination }}
        onSlideChange={onSlideChange}
        sx={styles}>
        {categoriesList &&
          categoriesList.map(({ title }, index) => {
            const itemKey = `carousel-categorie-${index}`
            return (
              <SwiperSlide
                data-testid={getTestId('swiper-slide')}
                key={itemKey}
                onClick={(e) => categoryActions && categoryActions(e)}>
                <CategoryWrapper>
                  <span className="carousel-categorie-title">{title}</span>
                </CategoryWrapper>
              </SwiperSlide>
            )
          })}
        {!!items &&
          items.map((item, index) => {
            const itemKey = item.id || item.sku || `item-${index}`

            return (
              <SwiperSlide
                data-testid={getTestId('swiper-slide')}
                key={itemKey}>
                <ItemCard
                  item={item}
                  data-testid={getTestId('item-card')}
                  {...itemCardProps}
                />
              </SwiperSlide>
            )
          })}
        {!!images &&
          images.map(({ image: imageSrc, data, title }, index) => {
            const itemKey = `carousel-image-${index}`

            return (
              <SwiperSlide
                data-testid={getTestId('swiper-slide')}
                key={itemKey}
                onClick={(e) => handleClick(e, data)}>
                {title ? (
                  <ImageWrapper>
                    <Image
                      src={imageSrc}
                      {...image}
                      data-testid={getTestId('image')}
                    />
                    <span>{title}</span>
                  </ImageWrapper>
                ) : (
                  <Image
                    src={imageSrc}
                    {...image}
                    data-testid={getTestId('image')}
                  />
                )}
              </SwiperSlide>
            )
          })}
      </CarouselWrapper>
    )
  }
  return null
}

export default Carousel
